/**
 * @module lib/number
 */

export { formatCurrency } from './formatCurrency.js';
export { formatOrdinal } from './formatOrdinal.js';

export const inc = x => Number(x) + 1;
export const dec = x => Number(x) - 1;
